import { COLORS } from '../../common/utils/icon/constants';
import { getIcon } from '../../common/utils/icon/icon';
const getStyles = notNeutral => `
  height: auto;
  ${notNeutral && 'margin-top: -4%'};
  width: ${notNeutral ? '62%' : '100%'};
`;
const configuration = {
  colors: [COLORS.blue, COLORS.white],
  getStyles,
  id: 'phone'
};
export default type => getIcon({
  ...configuration,
  type
});
//# sourceMappingURL=icon.js.map